import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '@/types/general';
export const Youtube = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_8_4707)"><path d="M18.601 2.58331C18.4941 2.18111 18.2833 1.81407 17.9899 1.51896C17.6964 1.22384 17.3306 1.01102 16.929 0.901808C15.447 0.502808 9.50001 0.502808 9.50001 0.502808C9.50001 0.502808 3.56251 0.502808 2.08051 0.901808C1.6776 1.01045 1.31026 1.22292 1.01519 1.51799C0.720116 1.81306 0.507646 2.1804 0.399008 2.58331C0.123849 4.09071 -0.00973298 5.62053 8.35967e-06 7.15281C-0.00973298 8.68508 0.123849 10.2149 0.399008 11.7223C0.507646 12.1252 0.720116 12.4926 1.01519 12.7876C1.31026 13.0827 1.6776 13.2952 2.08051 13.4038C3.56251 13.8028 9.50001 13.8028 9.50001 13.8028C9.50001 13.8028 15.4375 13.8028 16.9195 13.4038C17.3224 13.2952 17.6898 13.0827 17.9848 12.7876C18.2799 12.4926 18.4924 12.1252 18.601 11.7223C18.8762 10.2149 19.0097 8.68508 19 7.15281C19.0097 5.62053 18.8762 4.09071 18.601 2.58331ZM7.60001 10.0028V4.30281L12.54 7.15281L7.60001 10.0028Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="clip0_8_4707"><rect width="19" height="13.3" fill="white" transform="translate(0 0.502808)" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.className) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="currentColor" className={props.className}>{t0}{t1}</svg>;
    $[2] = props.className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};